(ns renolit-roofing-service.view.service.zone
  (:require [re-frame.core :as rf]
            ["react" :refer [useEffect useRef]]
            [reagent.core :as r]
            [renolit-roofing-service.config :as config]
            [renolit-roofing-service.layout.dropdown-menu :as layout.dropdown-menu]
            [renolit-roofing-service.layout.form :as layout.form]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.util.geometry :as util.geometry]
            [renolit-roofing-service.util.google-maps :as google-maps]
            [renolit-roofing-service.view.service.zone-revision-popup :as view.revision-popup]
            [renolit-roofing-service.view.service.delete-confirmation-popup :as view.delete-popup]
            ["@vis.gl/react-google-maps" :refer [APIProvider ControlPosition Map MapControl useMapsLibrary]]))

(rf/reg-sub
 ::project-address
 (fn [db _]
   (:project-address db)))

(rf/reg-sub
 ::map-center
 (fn [db _]
   (:map-center db)))

(rf/reg-event-fx
 ::set-map-center
 (fn [{:keys [db]} [_ center]]
   {:db (assoc db :map-center center)}))

(defn- zone-card*
  [{:zone/keys [name subzones zIndex pois]}]
  [:div.zone-card
   {:class (when (even? zIndex) ["zone-card--white-bg"])}
   [:div.zone-card__header
    [:span.zone-card__title name]
    (->> pois
         (filter (fn [poi] (= (:poi/type poi) :focused-revision)))
         (map (fn [poi]
                {:key (random-uuid)
                 :wp (get-in poi [:poi/work-package :wp])}))
         (distinct)
         (map (fn [wp] [google-maps/wp-marker wp "ml-4"])))
    (->> pois
         (filter (fn [poi] (= (:poi/type poi) :general-revision)))
         (map (fn [poi]
                {:key (random-uuid)
                 :wp (get-in poi [:poi/work-package :wp])}))
         (distinct)
         (map (fn [wp] [google-maps/wp-marker wp "ml-4 general-review-wp-icon"])))]
   (when (seq subzones)
     [:div.zone-card__children
      (doall
       (for [sz subzones]
         ^{:key (str "zone-" (:zone/id sz))}
         [zone-card* sz]))])])

(defn- zone-panel
  []
  (let [zones-tree (rf/subscribe [::google-maps/zones-tree])]
    (fn []
      [:div.zone-panel
       (doall
        (for [z @zones-tree]
          ^{:key (:zone/id z)}
          [zone-card* z]))])))

(defn- zone-placing-tool
  []
  (let [placing-tool (rf/subscribe [::google-maps/placing-tool])]
    (fn []
      [:div
       [:button.zone-placing-tool-btn
        {:type :button
         :class (when @placing-tool
                  "zone-placing-tool-btn--active")
         :on-click (fn [e]
                     (.stopPropagation e)
                     (if @placing-tool
                       (rf/dispatch [::google-maps/stop-placing])
                       (rf/dispatch [::google-maps/start-placing :zone])))}
        [:img {:src "/images/zone-division.svg"}]]])))

(defn- legends
  []
  [:div.zone-legends
   [:div.zone-legends-icon
    [google-maps/wp-marker {:wp :legend} "mr-4"]
    (t [(keyword "domain.choices.revision-type/focused-revision")])]
   [:div.zone-legends-icon
    [google-maps/wp-marker {:wp :legend} "mr-4 general-review-wp-icon"]
    (t [(keyword "domain.choices.revision-type/general-revision")])]])

(defn- map-controls
  []
  (fn []
    [:<>
     [:> MapControl {:position ControlPosition.TOP_RIGHT}
      [zone-placing-tool]]
     [:> MapControl {:position ControlPosition.TOP_LEFT}
      [zone-panel]]
     [:> MapControl {:position ControlPosition.BOTTOM_CENTER}
      [legends]]]))

(defn- poi
  [{:poi/keys [id type selected]} _parent-z-Index]
  (let [ref (useRef nil)]
    (useEffect
     (fn []
       (when (and (.-current ref) selected)
         (.scrollIntoView (.-current ref) #js {:behavior "smooth"}))
       js/undefined)
     #js [selected])
    ^{:key id}
    [:div
     (cond-> {:ref ref
              :on-click #(do
                           (.stopPropagation %)
                           (rf/dispatch [::google-maps/poi-selected id]))
              :style {:padding "0.5rem", :display "flex", :justify-content "space-between"}}
       selected
       (update :style merge {:border "1px solid black"}))
     (case type

       :focused-revision
       "Focused revision"

       :general-revision
       "General revision")
     [:button
      {:type :button
       :on-click #(do
                    (.stopPropagation %)
                    (rf/dispatch [::google-maps/poi-deleted id]))}
      "Delete"]]))

(defn- work-package-card
  [zones {:poi/keys [id type work-package parent-zone-id context-coordinates] :as poi} parent-zIndex]
  (let [wp-title (t [(keyword (str "domain.choices.wp/" (name (:wp work-package))))])]
    [:div.work-package-card
     {:key id
      :class (when (odd? parent-zIndex) ["zone-card--white-bg"])}
     [:div.work-package-card__header
      [:span.work-package-card__title
       [google-maps/wp-icon {:key id :wp (:wp work-package)}]
       wp-title]
      [:div.zone-card__actions
       [:button.flat-btn
        {:type :button
         :on-click (fn [_]
                     (let [zone (get zones parent-zone-id)]
                       (rf/dispatch [::google-maps/close-gmaps-options-menu])
                       (rf/dispatch [::view.revision-popup/open
                                     {:popup-mode :edit
                                      :work-package work-package
                                      :context-zone (when (= type :general)  zone)
                                      :review-type (if (= type :general-revision)
                                                     :general
                                                     :focused)
                                      :on-submit (fn [review]
                                                   (rf/dispatch [::google-maps/poi-updated
                                                                 {:id id
                                                                  :poi-type type
                                                                  :coordinates context-coordinates
                                                                  :parent-zone-id parent-zone-id
                                                                  :work-package review}]))}])))}
        [layout.icon/icon {:key :edit}]]
       [:button.btn.flat-btn
        {:type :button
         :on-click #(rf/dispatch [::view.delete-popup/open
                                  {:item-title wp-title
                                   :on-submit (fn []
                                                (rf/dispatch [::google-maps/poi-deleted id]))}])}
        [layout.icon/icon {:key :delete}]]]]
     [:div.work-package-card__details
      (when (not= (:wp-type work-package) :nil)
        [:span.work-package-card__subtitle
         (t [(keyword (str "domain.choices.wp-type/" (name (:wp-type work-package))))])])
      (doall
       (map-indexed
        (fn [idx {:keys [task-type comment]}]
          ^{:key (str (name task-type) "-" idx)}
          [:<>
           [:span.work-package-card__subtitle
            (t [(keyword (str "domain.choices.task-type/" (name task-type)))])]
           [:div.work-package-card__subtitle
            [layout.icon/icon {:key :message :class "mr-4"}]
            [:span.task-card__comments-text comment]]])
        (:tasks work-package)))]]))

(defn- work-package-group
  [zones pois parent-zIndex]
  (let [pois* (->> (or pois #{})
                   (filter #(get zones %)))
        pois-by-type
        (group-by (fn [poi-id]
                    (:poi/type (get zones poi-id)))
                  pois*)]
    [:<>
     (doall
      (for [[wp-type poi-ids] pois-by-type]
        ^{:key (str "poi-type-" (name wp-type))}
        [:div.work-package-group
         {:class (when (even? parent-zIndex) ["work-package-group--white-bg"])}
         [:span.work-package-group__title
          (t [(keyword (str "page.zone." (name wp-type)))])]
         [:div.work-package-group__list
          (doall
           (for [poi-id poi-ids]
             ^{:key (str "poi-" poi-id)}
             [work-package-card zones (get zones poi-id) parent-zIndex]))]]))]))

(defn- zone-header
  [_zone-id zone-name _z-index]
  (let [state (r/atom {:editing? false
                       :zone-name zone-name})]
    (fn [zone-id zone-name z-index]
      [:div.zone-card__header
       (if-not (:editing? @state)
         [:<>
          [:span.zone-card__title
           {:class (when (> z-index 0) ["zone-card__title--subzone"])}
           zone-name]
          [:div.zone-card__actions
           [:button.flat-btn
            {:type :button
             :on-click #(swap! state assoc :editing? true)}
            [layout.icon/icon {:key :edit}]]
           [:button.flat-btn
            {:type :button
             :on-click #(rf/dispatch [::view.delete-popup/open
                                      {:item-title zone-name
                                       :on-submit (fn []
                                                    (rf/dispatch [::google-maps/zone-deleted zone-id]))}])}
            [layout.icon/icon {:key :delete}]]]]
         [:<>
          [layout.form/item
           {:context :context
            :type :input
            :state state
            :path [:zone-name]
            :schema [:string]
            :placeholder-transl-kw :placeholder/zone-name
            :mandatory? true}]
          [:div.zone-card__actions
           [:button.flat-btn
            {:type :button
             :on-click #(do
                          (swap! state assoc :editing? false)
                          (rf/dispatch [::google-maps/zone-renamed
                                        zone-id (:zone-name @state)]))}
            [layout.icon/icon {:key :success}]]
           [:button.flat-btn
            {:type :button
             :on-click #(swap! state assoc :editing? false)}
            [layout.icon/icon {:key :cancel}]]]])])))

(defn- zone-card
  [zones {:zone/keys [id name subzones pois _parent-zone-id zIndex]}]
  [:div.zone-card
   {:class (when (odd? zIndex) ["zone-card--white-bg"])}
   [zone-header id name zIndex]
   (when (or (seq subzones)
             (seq pois))
     [:div.zone-card__children
      [work-package-group zones pois zIndex]
      (doall
       (for [zid (or subzones [])]
         ^{:key (str "zone-" zid)}
         [:f> zone-card zones (get zones zid)]))])])

(defn- zone-hierarchy
  [zones]
  (let [zone-nodes (vals zones)
        zone-nodes (filter :zone/id zone-nodes)
        root-zones (filter #(nil? (:zone/parent-zone-id %)) zone-nodes)]
    [:div.zones
     [:h1.zones__title (t [:common/zones-indicated])]
     [:div.zones__list
      (doall
       (for [z root-zones]
         ^{:key (:zone/id z)}
         [:f> zone-card zones z]))]]))

(defn- map-context-menu
  [_zones]
  (let [pos (rf/subscribe [::google-maps/gmaps-options-menu])]
    (fn [zones]
      (when-let [{:keys [context-position context-coordinates parent-zone-id]} @pos]
        [:> layout.dropdown-menu/menu
         {:contextual? true
          :contextPosition (clj->js context-position)}
         [:> layout.dropdown-menu/menu-item
          {:id 1
           :key 1
           :label (t [:page.zone/general-revision])
           :onClick (fn [_]
                      (let [zone (get zones parent-zone-id)]
                        (rf/dispatch [::google-maps/close-gmaps-options-menu])
                        (rf/dispatch [::view.revision-popup/open
                                      {:popup-mode :create
                                       :context-zone zone
                                       :review-type :general
                                       :on-submit (fn [review]
                                                    (rf/dispatch [::google-maps/poi-created
                                                                  {:poi-type :general-revision
                                                                   :coordinates context-coordinates
                                                                   :parent-zone-id parent-zone-id
                                                                   :work-package review}]))}])))}]
         [:> layout.dropdown-menu/menu-item
          {:id 2
           :key 2
           :label (t [:page.zone/focused-revision])
           :onClick (fn [_]
                      (rf/dispatch [::google-maps/close-gmaps-options-menu])
                      (rf/dispatch [::view.revision-popup/open
                                    {:popup-mode :create
                                     :review-type :focused
                                     :on-submit (fn [review]
                                                  (rf/dispatch [::google-maps/poi-created
                                                                {:poi-type :focused-revision
                                                                 :coordinates context-coordinates
                                                                 :parent-zone-id parent-zone-id
                                                                 :work-package review}]))}]))}]]))))

(defn geocode-center
  [address]
  (let [geocoding-lib (useMapsLibrary "geocoding")]
    (useEffect
     (fn []
       (when (and geocoding-lib address)
         (let [^google.maps.GeocodingLibrary.Geocoder geocoder (new (.-Geocoder geocoding-lib))]
           (-> (.geocode geocoder (clj->js {:address address}))
               (.then (fn [response]
                        (let [resp (js->clj response {:keywordize-keys true})
                              loc (get-in resp [:results 0 :geometry :location])]
                          (rf/dispatch
                           [::set-map-center
                            {:lat (.lat loc)
                             :lng (.lng loc)}])))))))
       js/undefined)
     #js [geocoding-lib, address])
    [:<>]))

(defn- zones
  []
  (let [zones (rf/subscribe [::google-maps/zones])
        project-address (rf/subscribe [::project-address])
        center (rf/subscribe [::map-center])]
    [:div.project_sections-outer-container
     {:style {:display "grid" :grid-template-columns "2fr 1fr"}}
     [:f> geocode-center @project-address]
     (if @center
       [:> Map
        {:mapId "DEMO_MAP_ID"
         :mapTypeId "satellite"
         :tilt 0
         :defaultZoom 20
         :minZoom 18
         :style {:height "75vh"}
         :defaultCenter @center
         :disableDefaultUI true
         :zoomControl true
         :keyboardShortcuts false
         :restriction (clj->js
                       {:latLngBounds
                        (util.geometry/restriction-from-center
                         @center
                         {:delta-lat 0.003})
                        :strictBounds true})
         :onClick (fn [gmaps-mouse-evt]
                    (let [latLng (.. gmaps-mouse-evt -detail -latLng)
                          context-coordinates {:lat (.-lat latLng)
                                               :lng (.-lng latLng)}]
                      (rf/dispatch [::google-maps/map-clicked context-coordinates])))}
        [:f> google-maps/gmaps-bridge!]
        [:f> google-maps/zone-labels]
        [map-context-menu @zones]
        [map-controls]]
       [:div {:style {:height "75vh"}}])
     [zone-hierarchy @zones]]))

(defn main
  []
  (let [config (rf/subscribe [::config/config-data])]
    (fn []
      (let [{:keys [google-maps-api-key]} @config]
        [:> APIProvider
         {:apiKey google-maps-api-key}
         [zones]]))))
